import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../../forecast-app/shared/util/util';
import {trackEvent} from '../../../tracking/amplitude/TrackingV2';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../../mutations/MutationTypes';
import {
	SaveBaselineAsTemplateInput,
	SaveBaselineAsTemplateMutation,
} from './__generated__/SaveBaselineAsTemplateMutation.graphql';

const mutation = graphql`
	mutation SaveBaselineAsTemplateMutation($input: SaveBaselineAsTemplateInput!) {
		saveBaselineAsTemplate(input: $input) {
			baselineTemplate {
				id
				name
			}
			company {
				id
				...BaselineTemplatesList_company
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<SaveBaselineAsTemplateInput>,
	onSuccess?: RelayOnCompleted<SaveBaselineAsTemplateMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<SaveBaselineAsTemplateMutation>(environment, {
		mutation,
		variables,
		onCompleted: (response, errors) => {
			if (!errors?.length) {
				trackEvent('Baseline Template', 'Saved from Baseline');
			}
			onSuccess?.(response, errors);
		},
		onError: onError,
	});
}

export default {commit};
